import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { DialogProvider } from "./context/DialogProvider";
// import reportWebVitals from './reportWebVitals';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserProvider } from "./context/UserContext";
import { PendingRequestProvider } from './context/PendingRequestContext';
import PendingCompOffRequestProvider from "./context/PendingCompOffRequestContext";
import PendingCompPayRequestProvider from "./context/PendingCompPayRequestContext";
import PendingPaySlipRequestProvider from "./context/PendingPaySlipRequestContext";
import { SavedAnnouncementsCountProvider } from "./context/SavedAnnouncementsCountContext";
import PendingOnDutyRequestProvider from "./context/PendingOnDutyRequestContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
     <DialogProvider>
        <UserProvider>
          <PendingRequestProvider>
            <PendingOnDutyRequestProvider>
              <PendingCompOffRequestProvider>
                <PendingCompPayRequestProvider>
                  <PendingPaySlipRequestProvider>
                    <SavedAnnouncementsCountProvider>
                      <App />
                      <ToastContainer />
                    </SavedAnnouncementsCountProvider>
                  </PendingPaySlipRequestProvider>
                </PendingCompPayRequestProvider>
              </PendingCompOffRequestProvider>
            </PendingOnDutyRequestProvider>
           </PendingRequestProvider>
        </UserProvider>
      </DialogProvider>
  </React.StrictMode>
);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
